// VER-218: role guard for Console routes (extends RequireAuth with a role check).
// `roles` is an array of allowed roles, e.g. ["account_admin", "internal_admin"].
// Note: this is UI convenience only — the backend enforces RBAC at the API layer.
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useSession } from "./useSession";

export default function RequireRole({
  roles,
  children,
  redirectTo = "/console/login",
  deniedTo = "/console",
}) {
  const { status, user } = useSession();

  if (status === "loading") {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }
  if (status !== "authenticated") return <Navigate to={redirectTo} replace />;
  if (roles && !roles.includes(user?.role)) return <Navigate to={deniedTo} replace />;
  return children;
}
